<div class="page-container">
  <div class = "main-body">
    <div class="section-container">
      <h1 class="mat-display-medium">Conditions We Treat</h1>
    </div>
    <div class="section-container">
      <div class="condition-list">
        <app-condition-card
          class = app-condition-card
          *ngFor="let condition of conditionList"
          [condition]="condition"
        ></app-condition-card>
      </div>
    </div>
    <div class="section-container">
      <h2>Useful Websites About Conditions</h2>
    </div>

    <div class="section-container">
      <app-useful-links></app-useful-links>
    </div>
  </div>
</div>
